import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();

class Follow_up_allocated_veh extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            allovehs: [],
            allovehsl: false,

            cushow: false,
            dateofallocation:'',
            dateofallocationt:'',
        }
    }

    async componentDidMount() {
        this.get_follow_up_allocated_veh();
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    get_follow_up_allocated_veh = () => {
        let baseurl = myconfig.get_follow_up_allocated_veh_date;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            allovehs: [],
            allovehsl: false,
            cushow: false,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    allovehs: res.data,
                    allovehsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    tabledata = () => {
        let count = 0;
        let retdata = null;
        if (this.state.allovehsl) {
            retdata = this.state.allovehs.datas.map(value => {
                let manage = null;
                let report = null;
                if (this.state.allovehs.usermatrix.update)
                    manage =
                        <td><a href="#"
                               onClick={(event => this.showcu(event, value.id))}>Manage</a></td>
                if (this.state.allovehs.usermatrix.update)
                    report =
                        <td><a href={myconfig.redirectomovement_by_allocationveh+"?id="+value.id} target="_blank">Report</a></td>

                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    {manage}
                    {report}
                    <td>{value.plate_no}</td>
                    <td>{value.status}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.status}</td>
                    <td>{value.orderdate}</td>
                    <td>{value.volume}</td>
                    <td>{value.sale_type}</td>
                    <td>{value.customer_id}</td>
                    <td>{value.created_at}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }

    showcu = (event, id = -1) => {
        event.preventDefault()
        var date = new Date();
        this.setState({
            id: id,
            cushow: true,
            dateofallocation:date.toISOString().split('T')[0],
            dateofallocationt:'00:00',
        })
    }
    hidecu = () => {
        this.setState({
            cushow: false,
        })
    }
    modalcu = () => {
        return (<Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.cushow}
                onHide={this.hidecu}>
                <Modal.Header><h4>Allocation Date</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Allocation Date</h3>
                                </div>
                                <form>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Allocation Date</label>
                                                        <input className="form-control" type="date" name="dateofallocation"
                                                               onChange={this.inputmgt} value={this.state.dateofallocation}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Time</label>
                                                        <input className="form-control" type="text" name="dateofallocationt"
                                                               onChange={this.inputmgt} value={this.state.dateofallocationt} placeholder={"HH:MM"}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button type="submit" className="btn btn-primary"
                                                onClick={event => this.submitcu(event)}>Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    submitcu = (event) => {
        event.preventDefault()
        Swal.fire({
            title: 'Do you want to save the data?',
            showDenyButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                let baseurl = myconfig.follow_up_allocated_veh_date;
                let redirecttologin = myconfig.redirecttologin;
                axios.post(baseurl, {
                    sid: window.localStorage.getItem("ntfms_sid"),
                    allocateveh_id: this.state.id,
                    dateofallocation: this.state.dateofallocation,
                    dateofallocationt: this.state.dateofallocationt,
                }, {cancelToken: source.token}).then(res => {
                    console.log(res.data)
                    if (res.data.auth == false) {
                        window.localStorage.setItem("ntfms_sid", null);
                        window.localStorage.setItem("ntfms_username", null);
                        window.localStorage.setItem("ntfms_name", null);
                        var win = window.open(redirecttologin, "_self");
                    } else if (res.data.success == false) {
                        Swal.fire({
                            title: 'Error!',
                            text: res.data.msg,
                            icon: 'error',
                            confirmButtonText: 'Okay'
                        })
                    } else {
                        Swal.fire({
                            title: 'success!',
                            text: res.data.msg,
                            icon: 'success',
                            confirmButtonText: 'Okay'
                        }).then(value => {
                            this.get_follow_up_allocated_veh()
                        })
                    }
                }).catch((e) => {
                    console.log(e.message);
                });
            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        })

    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    render() {
        let manage = null;
        let report=null;
        if (this.state.allovehsl) {
            if (this.state.allovehs.usermatrix.update)
                manage =
                    <th>Manage</th>
            if (this.state.allovehs.usermatrix.update)
                report =
                    <th>Report</th>
        }
        return (
            <>
                <Nav type="follow_up_allocated_veh"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Allocation date management</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Allocation date</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="table_search"
                                                       className="form-control float-right" placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <a href={myconfig.redirectofollow_up_report+"?type=1"}
                                                   className="btn btn-xs btn-outline-primary btn-block" target="_blank">All Report</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                {manage}
                                                {report}
                                                <th>Truck Plate #</th>
                                                <th>Truck Status</th>
                                                <th>Driver Name</th>
                                                <th>Driver Phone</th>
                                                <th>Trailer #</th>
                                                <th>Status</th>
                                                <th>Order Date</th>
                                                <th>Volume</th>
                                                <th>Sale Type</th>
                                                <th>Customer</th>
                                                <th>Create at</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
                {this.modalcu()}
            </>
        )
    }
}

export default Follow_up_allocated_veh;
